/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { When } from "react-if";
import { useHistory } from "react-router-dom";
import { Heading, Message, Spacer, SVGIcon } from "@nordcloud/gnui";
import { InfoCard } from "~/components";
import { ROUTES } from "~/routing/routes";

type Props = {
  notificationGroupId: string;
  onAddNewNotificationGroup: () => void;
};

export function Summary({
  notificationGroupId,
  onAddNewNotificationGroup,
}: Props) {
  const history = useHistory();

  return (
    <Row justify="center">
      <Col sm={6} md={6} lg={8}>
        <Spacer height="1rem" />
        <When condition={() => true}>
          <Row>
            <Col>
              <Message status="success" image="success">
                Notification group has been added
              </Message>
            </Col>
          </Row>
          <Spacer height="2rem" />
        </When>
        <Row>
          <Col lg={4}>
            <InfoCard
              align="center"
              onClick={() => {
                history.push(
                  ROUTES.notificationGroups.generateDetails(notificationGroupId)
                );
              }}
              data-testid="Details"
            >
              <SVGIcon name="detailsView" size="xl" />
              <Heading marginTop="1rem" level={4}>
                Notification Group Details
              </Heading>
            </InfoCard>
          </Col>
          <Col lg={4}>
            <InfoCard
              align="center"
              onClick={() => history.push(ROUTES.notificationGroups.index)}
              data-testid="List"
            >
              <SVGIcon name="listView" size="xl" />
              <Heading marginTop="1rem" level={4}>
                List of Notification Groups
              </Heading>
            </InfoCard>
          </Col>
          <Col lg={4}>
            <InfoCard
              align="center"
              onClick={onAddNewNotificationGroup}
              data-testid="Add another"
            >
              <SVGIcon name="wizardView" size="xl" />
              <Heading marginTop="1rem" level={4}>
                Add Another Notification Group
              </Heading>
            </InfoCard>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
